import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../services/common/localstorage-service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localstorageService = inject(LocalStorageService);
  const token = localstorageService.get('token'); // or sessionStorage, or a service

  if (token) {
    return true;
  } else {
    router.navigate(['/'], { queryParams: { returnUrl: state.url } });
    return false;
  }
};
